import React from "react";
import { Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import PlanCards from "../PlansCard/planCards";
import { plan } from "../../Config/features";

const Plans = () => {
  const { t } = useTranslation();

  return (
    <Row className="m-0 mt-5 pt-3 p-0 w-100 d-flex justify-content-center ">
      <Row className=" text-center d-flex justify-content-center align-items-center">
        <p className="m-0 w_40 w-xs-100 px-5 line_height_3_063 text_40 productSansBold">
          <span>{t("PricingTitle1")}</span>
          <span className="mx-2  landing_banner_Heading productSansBold">
            {t("PricingTitlespan")}
          </span>
          {t("PricingTitle2")}
        </p>
      </Row>
      <Row className="d-flex mt-3 justify-content-center">
        <p className="w_67 w-xs-90 mt-1 text-black productSansLight text-center text_18 px-3">
          {t("PricingSubTitle")}
        </p>
      </Row>
      <Row className="m-0 w-100 w-xs-100 p-lg-5 mb-3 pb-0 d-flex align-items-start align-items-lg-center justify-content-center ">
        <PlanCards plan={plan.freeplan} classes={"free"} arrow={true} />
        <PlanCards plan={plan.premPlan} classes={"prem"} />
        <PlanCards plan={plan.enterprisePlan} classes={"enterprise"} />
      </Row>
    </Row>
  );
};
export default Plans;
